var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1641 10.05C20.1641 4.53005 15.6841 0.0500488 10.1641 0.0500488C4.64406 0.0500488 0.164062 4.53005 0.164062 10.05C0.164062 14.89 3.60406 18.92 8.16406 19.85V13.05H6.16406V10.05H8.16406V7.55005C8.16406 5.62005 9.73406 4.05005 11.6641 4.05005H14.1641V7.05005H12.1641C11.6141 7.05005 11.1641 7.50005 11.1641 8.05005V10.05H14.1641V13.05H11.1641V20C16.2141 19.5 20.1641 15.24 20.1641 10.05Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e1f38bed089005c321de114e9298d7e5.svg";
export { ForwardRef as ReactComponent };